import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type PageHeaderProps = ComponentProps<"header">

function PageHeader(props: PageHeaderProps) {
  const { className, ...headerProps } = props
  return <header className={cn("page-header", className)} {...headerProps} />
}

export default PageHeader
